<template>
  <table v-if="localTrainings" class="table table-trainings">
    <tr>
      <th>
        <div>{{ $t('src/components/training/trainingtable.459') }}</div>
      </th>
      <th>
        <div>{{ $t('src/components/training/trainingtable.9661') }}</div>
      </th>
      <th>
        <div>{{ $t('src/components/training/trainingtable.5179') }}</div>
      </th>
      <th>
        <div>{{ $t('src/components/training/trainingtable.6926') }}</div>
      </th>
      <th>
        <div>{{ $t('src/components/training/trainingtable.6288') }}</div>
      </th>
      <th>
        <div>{{ $t('src/components/training/trainingtable.6906') }}</div>
      </th>
      <th>
        <div>{{ $t('src/components/training/trainingtable.1288') }}</div>
      </th>
    </tr>
    <tr v-for="(week, index) in trainingsCalendar" :key="index">
      <td v-for="day in week" :key="day.format">
        <training-table-day
          :day="day"
          :trainings="day.trainings"
          :has-rights-to-edit="hasRightsToEdit"
          :saving="saving"
          @remove="
            id => {
              removeTraining(day, id)
            }
          "
          @addTraining="addTraining(day)"
        >
        </training-table-day>
      </td>
    </tr>
  </table>
</template>

<script>
import { trainingDate } from '@/mixins/training-date.js'
import { nowMoment } from '@/mixins/now-moment'
import { trainingItem } from '@/mixins/training-item.js'
import { DATE_FORMAT } from '@/main.config'
import('@/styles/components/trainings-list.less')

export default {
  name: 'TrainingTable',
  components: {
    TrainingTableDay: () => import('@/components/Training/TrainingTableDay.vue')
  },
  mixins: [trainingDate, nowMoment, trainingItem],
  props: {
    trainings: {
      type: Array,
      required: true
    },
    hasRightsToEdit: {
      type: Boolean,
      required: false,
      default: false
    },
    saving: {
      type: Boolean,
      required: false,
      default: false
    },
    month: {
      type: Number,
      required: false
    },
    year: {
      type: Number,
      required: false
    }
  },
  data: () => ({
    localTrainings: null,
    currentYear: null
  }),
  computed: {
    groupedTrainings() {
      let data = {}
      this.trainings.forEach(training => {
        const date = this.getTrainingFormattedStartDate(training)
        if (!data[date]) {
          data[date] = []
        }
        data[date].push(training)
      })
      return data
    },
    lastIndex() {
      let idx = this.trainings.findIndex(item => {
        let month = item.date_start
          ? this.moment(item.date_start).month()
          : this.moment(item.date_plan).month()
        return month > this.month
      })
      if (idx < 0) return this.trainings.length - 1
      else return idx - 1
    },
    firstIndex() {
      let idx = this.trainings.findIndex(item => {
        let month = item.date_start
          ? this.moment(item.date_start).month()
          : this.moment(item.date_plan).month()
        return month == this.month
      })

      return idx
    },
    lastTraining() {
      return this.trainings[this.lastIndex]
    },
    firstTraining() {
      return this.trainings[this.firstIndex]
    },
    firstTrainingDate() {
      let res = this.getTrainingMomentStartDate(this.firstTraining)
      return res
    },
    lastTrainingDate() {
      return this.getTrainingMomentStartDate(this.lastTraining)
    },
    firstWeekDate() {
      if (!this.firstTrainingDate) {
        return null
      }
      return this.firstTrainingDate.isoWeekday('Monday')
    },
    lastWeekDate() {
      if (!this.lastTrainingDate) {
        return null
      }
      return this.lastTrainingDate.isoWeekday('Sunday')
    },
    trainingsCalendar() {
      let dates = []
      const firstDay = this.moment.utc([this.year, this.month, 1]).isoWeekday('Monday')
      const lastDay = this.moment.utc(this.moment.utc([this.year, this.month, 1])).endOf('month')
      while (firstDay.isSameOrBefore(lastDay, 'day')) {
        dates.push(
          Array(7)
            .fill(0)
            .map(() => {
              const day = {
                format: firstDay.format(DATE_FORMAT[`${this.$store.getters.LOCALE}`]),
                date: firstDay.format(DATE_FORMAT.server),
                month: firstDay.format('MMMM'),
                isAfterNow: firstDay.isAfter(this.nowMoment, 'day'),
                trainings: this.groupedTrainings[
                  firstDay.format(DATE_FORMAT[`${this.$store.getters.LOCALE}`])
                ]
              }
              firstDay.add(1, 'day')
              return day
            })
        )
      }
      dates[0][0].isFirst = true
      return dates
    }
  },
  watch: {
    trainings() {
      this.localTrainings = this.trainings
    },
    trainingsCalendar() {
      this.currentYear = this.firstTrainingDate ? this.firstTrainingDate.year() : this.currentYear
    }
  },
  created() {
    this.localTrainings = this.trainings
  },
  methods: {
    addTraining(day) {
      const date = this.moment(day.format, DATE_FORMAT[`${this.$store.getters.LOCALE}`])
      day.saving = true
      this.$emit('create', date.format(DATE_FORMAT.server))
    },
    removeTraining(day, id) {
      day.trainings = null
      this.$emit('remove', id)
    }
  }
}
</script>
